/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import * as styles from './index.css';

class Lightbox extends Component {
  constructor() {
    super();

    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);

    this.docBod = document.querySelector('body');
  }

  componentDidMount() {
    // Save the parent
    this.parent = this.lightbox.parentNode;
    // Now move this to body
    this.docBod.appendChild(this.lightbox);
    this.docBod.style.overflow = 'hidden';

    const isBodyBigger = this.docBod.getBoundingClientRect().width >
      this.elm.getBoundingClientRect().width;

    const widthDifference = (this.docBod.getBoundingClientRect().width -
      this.elm.getBoundingClientRect().width) / 2;

    this.elm.style.left = isBodyBigger ? `${widthDifference}px` : '0';
  }

  componentWillUnmount() {
    // Move back to parent
    this.parent.appendChild(this.lightbox);
    this.docBod.style.overflow = 'auto';
  }

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  render() {
    return (
      <div
        className={styles.lightboxWrapper}
        ref={(lightbox) => { this.lightbox = lightbox; }}
      >
        <div
          className={styles.wrapperClick}
          onClick={this.props.onClose}
        >
          <div
            className={styles.lightbox}
            style={this.props.wrapperStyle}
            ref={(elm) => { this.elm = elm; }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
  /* eslint-enable */
}

Lightbox.propTypes = {
  children: React.PropTypes.node,
  onClose: React.PropTypes.func,
  wrapperStyle: React.PropTypes.object,
};

export default Lightbox;



// WEBPACK FOOTER //
// ./app/components/lightbox/index.js